import React from 'react';

import { Tabs, TabsList, TabsTrigger } from '@/components/shadcn/ui/tabs';
import { NavigationLinks, useAdminStore } from '@/shared';
import { cn } from '@/utils';

import { useMainNavigation } from '../../hooks/useMainNavigation';

const triggerStyles = () => ['h-full rounded-xl text-lg px-10 font-cocogoose font-medium px-4 hover:bg-foreground'];

const HeaderNavigation: React.FC = () => {
  const { isAdmin } = useAdminStore();
  const { currentNav, onNavChange } = useMainNavigation();

  return (
    <nav>
      <Tabs value={currentNav} onValueChange={onNavChange}>
        <TabsList className={cn('bg-background flex flex-row gap-1 rounded-2xl p-1')}>
          <TabsTrigger className={cn(triggerStyles())} value={NavigationLinks.SWAP}>
            <span>Swap</span>
          </TabsTrigger>

          <TabsTrigger className={cn(triggerStyles())} value={NavigationLinks.HISTORY}>
            <span>History</span>
          </TabsTrigger>

          {isAdmin && (
            <TabsTrigger className={cn(triggerStyles())} value={NavigationLinks.EARN}>
              <span>Earn</span>
            </TabsTrigger>
          )}
        </TabsList>
      </Tabs>
    </nav>
  );
};

export default HeaderNavigation;
